import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button, Input } from "reactstrap";

function AdminSingleCouponPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const couponUid = params.couponUid;

  const [couponObject, setCouponObject] = useState();
  const [code, setCode] = useState("");
  const [type, setType] = useState("");
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("");

  const fetchCoupon = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "discountCodes"),
        where("uid", "==", couponUid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setCouponObject(data);
      setCode(data.code);
      setType(data.type);
      setValue(data.value);
      setStatus(data.status);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching coupon data");
    }
  };

  useEffect(() => {
    if (couponUid) {
      fetchCoupon();
    }
    // eslint-disable-next-line
  }, [couponUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this coupon?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const couponRef = query(
            collection(db, "discountCodes"),
            where("uid", "==", couponUid)
          );
          const findCoupons = await getDocs(couponRef);
          findCoupons.forEach(async (couponObject) => {
            const getCoupon = doc(db, "discountCodes", couponObject.id);
            await updateDoc(getCoupon, {
              code: code,
              type: type,
              value: value,
              status: status,
            }).then(() => {
              fetchCoupon();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteCoupon = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this coupon?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const couponRef = query(
            collection(db, "discountCodes"),
            where("uid", "==", couponUid)
          );
          const findCoupons = await getDocs(couponRef);
          findCoupons.forEach(async (couponObject) => {
            const getCoupons = doc(db, "discountCodes", couponObject.id);
            await deleteDoc(getCoupons);
          });

          Swal.fire({
            text: "Coupon deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting coupon");
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        COUPON
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Code
        </p>
        <input
          type="text"
          className="mainInput"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="The coupon's code"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Type
        </p>
        <Input
          type="select"
          className="mainInput"
          value={type}
          onChange={(e) => setType(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The coupon's type
          </option>
          <option value="$">$</option>
          <option value="%">%</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Value
        </p>
        <input
          type="number"
          className="mainInput"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="The coupon's value"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Status
        </p>
        <Input
          type="select"
          className="mainInput"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The coupon's status
          </option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </Input>
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            code === couponObject?.code &&
            type === couponObject?.type &&
            status === couponObject?.status &&
            parseInt(value) === couponObject?.value
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteCoupon}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleCouponPage;
